<canvas #editor [style.width.px]="editorWidth" [style.height.px]="editorHeight"></canvas>
